function additiveInverseArray(arr) {
    return arr.map((i) => -i);
}
export { additiveInverseArray };
